import type { IconData } from '@stacksjs/iconify-core'

export const basicUiToggle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.5A3.5 3.5 0 0 1 3.5 0h9a3.5 3.5 0 1 1 0 7h-9A3.5 3.5 0 0 1 0 3.5m4.75 0a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0M0 12.5A3.5 3.5 0 0 1 3.5 9h9a3.5 3.5 0 1 1 0 7h-9A3.5 3.5 0 0 1 0 12.5m13.75 0a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiToggle
